<template>
  <div class="d-flex">
    <div class="wrapper_grid"
    :class="$vuetify.breakpoint.mdAndUp ? 'container':'container'">
      <div class="wrapper_grid_profile">
        <v-form ref="form" @submit.prevent="submit" v-model="valid">
          <v-card width="100%" :outlined="!$store.state.isMobile" :flat="$store.state.isMobile">
              <v-card-title>
      <v-icon class="mr-3" color="primary">fa-user-circle</v-icon>
      {{$t('profile')}}
    </v-card-title>

            <v-card-text style="height:300px">
              <v-text-field
                dense
                outlined
                v-model="firstName"
                :rules="[() => !!firstName || '']"
                :label="$t('firstname')"
                required
              ></v-text-field>
              <v-text-field
                dense
                outlined
                v-model="name"
                :rules="[() => !!name || '']"
                :label="$t('name')"
                required
              ></v-text-field>
                <v-text-field
                dense
                outlined
                v-model="contactEmail"
                :rules="emailRules()"
                v-bind:label="$t('contactEmail')"
                persistent-hint
                :hint="$t('contactEmailHint')"
                required
              ></v-text-field>
              <v-text-field
                dense
                outlined
                v-model="login"
                :rules="emailRules()"
                v-bind:label="$t('loginEmail')"
                persistent-hint
                :hint="$t('loginEmailHint')"
                required
              ></v-text-field>

              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <a v-on="on">{{$t('changePassword')}}</a>
                </template>
                <v-form ref="formpswd" @submit.prevent="submit" v-model="validpswd">
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{$t('changePassword')}}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field
                              dense
                              outlined
                              type="password"
                              v-model="currentpwd"
                              :rules="[() => !!currentpwd || '']"
                              :label="$t('currentPassword')"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              dense
                              outlined
                              type="password"
                              v-model="newpwd"
                              :rules="[() => !!newpwd || '', () => (this.newpwd !== this.currentpwd) || 'Password must be new', () => ( /(?=.{8,})/.test(this.newpwd) || 'password weak')]"
                              :label="$t('newPassword')"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              dense
                              outlined
                              type="password"
                              v-model="confirmpwd"
                              :rules="[() => !!confirmpwd || '', () => (this.newpwd === this.confirmpwd) || 'Password must match']"
                              :label="$t('confirmPassword')"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">{{$t("cancel")}}</v-btn>
                      <v-btn color="primary" text @click="changePassword">{{$t("save")}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" depressed @click="submit">{{$t("save")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </div>
      <div class="wrapper_grid_customer">
        <customer v-if="$can('update','customers')"></customer>
      </div>
      <div class="wrapper_grid_storage">
        <storage class />
      </div>
    </div>
  </div>
</template>



<script>
import jwtdecode from "jwt-decode";
import { serviceihub } from "@/services/service.ihub.js";
const _serviceIhub = new serviceihub();
import sha256 from "sha256";
import customer from "@/components/pages/Users/Customer";
import storage from "@/components/pages/Users/Storage";

export default {
  components: {
    customer,
    storage
  },
  data: () => {
    return {
      dialog: false,
      id: null,
      firstName: null,
      name: null,
      login: null,
      contactEmail: null,
      show: false,
      valid: false,
      validpswd: false,
      currentpwd: null,
      newpwd: null,
      confirmpwd: null,
      password: null
    };
  },
  created() {
    this.id = jwtdecode(localStorage.getItem("auth")).contactId;
    this.firstName = jwtdecode(localStorage.getItem("auth")).given_name;
    this.name = jwtdecode(localStorage.getItem("auth")).family_name;
    this.login = jwtdecode(localStorage.getItem("auth")).sub;
    this.contactEmail = jwtdecode(localStorage.getItem("auth")).email;
  },
  methods: {
    emailRules() {
      return [
        v => !!v || "",
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "";
        }
      ];
    },
    changePassword() {
      const o = {
        id: this.id,
        currentpwd: sha256(this.currentpwd),
        newpwd: sha256(this.newpwd),
        ihubApplicationId: 2
      };

      _serviceIhub
        .updateCustomerContactPassword(o)
        .then(res => {
          if (res.data) {
            this.$noty.success('<i class="fas fa-check"></i>');
            this.dialog = false
          } else {
            this.$noty.error(this.$t("userNotFound"));
          }
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    submit() {
      if (this.valid && this.$refs.form.validate()) {
        const user = {
          id: this.id,
          name: this.name,
          firstName: this.firstName,
          login: this.login,
          email: this.contactEmail,
          CustomerContactId: this.id
        };
        this.$http
          .updateCustomerContact(user)
          .then(res => {
            localStorage.removeItem("auth");
            localStorage.removeItem("user");
            localStorage.setItem("auth", res.data);
            localStorage.setItem("user", `${this.firstName} ${this.name}`);
            this.$noty.success('<i class="fas fa-check"></i>');
            window.location = "/";
          })
          .catch(err => {
            this.$noty.error(err);
          });
      }
    }
  }
};
</script>


<style scoped>
.wrapper_grid {
  display: grid;
  grid-auto-columns: 2fr 2fr;
  grid-template-areas:
    "profile customer"
    "storage storage";
  grid-gap: 0.5rem;
}
.wrapper_grid_profile {
  grid-area: profile;
}

.wrapper_grid_customer {
  grid-area: customer;
}
.wrapper_grid_storage {
  grid-area: storage;
}

@media (max-width: 768px) {
  .wrapper_grid {
  
  grid-auto-columns: 1fr;
  grid-template-areas:
    "profile"
    "customer"
    "storage";
  }
}

</style>


// WEBPACK FOOTER //
// src/views/users/Profile.vue